export const request_a_quote_id = 'bm4f2gv';

export const book_a_demo_id = 'bdj4s56';

export const mel_id = 'bmz6zp5';

export const mql_id = 'bmfggqy';

export const referral_id = 'bdxqnxt';

export const affiliates_id = 'bh2d4g6';

export const beta_program_id = 'b6yute5';

export const beta_program_agreement_id = 'bwzy9z2';

export const subscribe_id = 'b1xblhp';

export const contact_id = 'bhczxog';

export const review_advice_id = 'bl6i971';

export const basic_form_id = 'bcwflyt';

export const cross_sell_id = 'bim74rj';

export const give_back_id = 'bxsgpjb';

export const rrn_id = 'bxw52fe';

export const code_conduct_id = 'bnsfzox';

export const double_optin_id = 'bnpu3kh';

export const touchtraveltaste_id = '3brpxkx';

export const omni_id = '32zcfy5';

export const privacy_rights_id = '34dq4i8';

const zapierWebhookIds = {
    request_a_quote_id,
    book_a_demo_id,
    mel_id,
    mql_id,
    referral_id,
    affiliates_id,
    beta_program_id,
    beta_program_agreement_id,
    subscribe_id,
    contact_id,
    review_advice_id,
    basic_form_id,
    cross_sell_id,
    give_back_id,
    rrn_id,
    code_conduct_id,
    double_optin_id,
    touchtraveltaste_id,
    omni_id,
};

export default zapierWebhookIds;
